import type { IconData } from '@stacksjs/iconify-core'

export const chevronDownRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 8V1a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronDownRight
